import { render, staticRenderFns } from "./administradores.vue?vue&type=template&id=173f12ac&"
import script from "./administradores.vue?vue&type=script&lang=js&"
export * from "./administradores.vue?vue&type=script&lang=js&"
import style0 from "./administradores.vue?vue&type=style&index=0&id=173f12ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports